import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getTrialStatus } from '../utils/trialUtils';

const TrialBanner = ({ userProfile }) => {
  const navigate = useNavigate();
  const status = getTrialStatus(userProfile);

  if (status.status === 'paid' || status.status === 'expired') return null;

  const { daysLeft } = status;
  const dayNumber = 7 - daysLeft + 1;

  let message;
  let urgency; // 'normal' | 'warning' | 'danger'

  if (daysLeft >= 3) {
    message = `✨ Trial Day ${dayNumber} of 7 — Upgrade for unlimited Pro access`;
    urgency = 'normal';
  } else if (daysLeft === 2) {
    message = '⚠️ 2 days left in your trial — Don\'t lose your progress!';
    urgency = 'warning';
  } else {
    message = '🚨 Last day of your trial — Upgrade now!';
    urgency = 'danger';
  }

  const styles = {
    normal: {
      background: 'var(--accent-subtle)',
      borderColor: 'var(--accent)',
      color: 'var(--accent)',
    },
    warning: {
      background: 'var(--warning-bg)',
      borderColor: 'var(--warning)',
      color: 'var(--warning)',
    },
    danger: {
      background: 'var(--danger-bg)',
      borderColor: 'var(--danger)',
      color: 'var(--danger)',
    },
  }[urgency];

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '8px',
        padding: '10px 16px',
        borderRadius: '8px',
        border: `1px solid ${styles.borderColor}`,
        background: styles.background,
        marginBottom: '16px',
        fontSize: '13px',
        fontWeight: 500,
        color: styles.color,
      }}
    >
      <span style={{ flex: '1 1 auto', minWidth: 0 }}>{message}</span>
      <button
        onClick={() => navigate('/pricing')}
        style={{
          flexShrink: 0,
          padding: '5px 14px',
          borderRadius: '6px',
          border: `1px solid ${styles.borderColor}`,
          background: styles.borderColor,
          color: 'var(--bg)',
          fontSize: '12px',
          fontWeight: 700,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        Upgrade Now
      </button>
    </div>
  );
};

export default TrialBanner;
